import { createContainer } from 'react-sweet-state';

import { VisualLanguageStore } from './VisualLanguageStore';

export const VisualLanguageStoreContainer = createContainer(VisualLanguageStore, {
  onInit:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
